import { useToast } from 'vue-toastification'

import { copyToClipboard } from '@/utils/copyToClipboard'

const toast = useToast()

const getParams = (message: string) => ({
  closeOnClick: false,
  bodyClassName: 'notification__copyable-text',
  onClick: () => copyToClipboard(message),
})

export const showError = (message: string) => {
  toast.error(message, getParams(message))
}

export const showSuccess = (message: string) => {
  toast.success(message, getParams(message))
}

export const showInfo = (message: string) => {
  toast.info(message, {
    ...getParams(message),
    timeout: 5000,
  })
}
